import { Form, Select } from "antd";
import PropTypes from "prop-types";

import HierarchicalComponents from "@/components/Elements/HierarchicalComponents/HierarchicalComponents";
import { useIsFormEnginePreviewMode } from "@/components/FormEngine/hooks/useIsFormEnginePreviewMode";
import { useContextInterventionAsset } from "@/features/Interventions/Details/InterventionContext";

import { COMPONENT_FIELD_DEPENDENCIES } from "./constants";
import { useSeverityGridFromInterventionAsset } from "./hooks/useSeverityGridFromInterventionAsset";
import { useSeverityGridSamplePreview } from "./hooks/useSeverityGridSamplePreview";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;
const { useFormInstance } = Form;

const InspectedComponent = ({ onChange, ...rest }) => {
  const form = useFormInstance();
  const isPreviewMode = useIsFormEnginePreviewMode();
  const severityGridPreview = useSeverityGridSamplePreview();
  const { isGridDefinedForAsset, severityGrid } =
    useSeverityGridFromInterventionAsset();
  const { id, name } = useContextInterventionAsset();

  const onComponentSelectionChange = (value = "") => {
    // we reset dependent fields before calling onChange, because this will trigger FormEngine
    // conditional visibility fields mechanism at time the Form.onValuesChange will be executed
    form.resetFields(COMPONENT_FIELD_DEPENDENCIES);
    onChange(value);
  };

  if (!isPreviewMode && !isGridDefinedForAsset) {
    return (
      <Select disabled={true} className="app-select-form-preview" value={id}>
        <Option key={id} value={id}>
          {name}
        </Option>
      </Select>
    );
  }

  return (
    <HierarchicalComponents
      components={isPreviewMode ? severityGridPreview : severityGrid}
      onChange={onComponentSelectionChange}
      {...rest}
    />
  );
};

export default InspectedComponent;

InspectedComponent.propTypes = {
  onChange: PropTypes.func,
};
